// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./student_single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import EventBusyIcon from "@mui/icons-material/EventBusy"; // Absent Form
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday"; // Half Leave Form
// import AccessTimeIcon from "@mui/icons-material/AccessTime"; // Late Form
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";

// const StudentSingle = () => {
//   // Extracting studentId using regular expressions
//   const location = useLocation();
//   // const studentId = location.pathname.match(/\/student\/(\d+)/);
//   const studentId = location.pathname.match(/\/student\/(\d+)/)?.[1];

//   const [student, setStudent] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const slugs = localStorage.getItem("slugs");
//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchstudent = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/student/${studentId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch student');
//       // }
//       const data = await response.json();
//       setStudent(data);
//       localStorage.setItem("studentData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };
//   const isPdf = (url) => {
//     return url?.toLowerCase().endsWith(".pdf");
//   };

//   // const AbsentformLinkString = "Absentform-Listing";
//   // const LateformLinkString = "Lateform-Listing";
//   // const LeaveformLinkString = "Leaveform-Listing";
//   // const HalfleaveformLinkString = "Halfleaveform-Listing";

//   useEffect(() => {
//     if (studentId) {
//       fetchstudent();
//     }
//   }, [studentId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="abbas">
//                 <h1 className="title">Student Info</h1>
//                 <div className="left">
//                   <div className="item">
//                     <img
//                       src={student?.data.image_url}
//                       alt=""
//                       className="itemImg"
//                     />
//                     <div className="item">
//                       {isPdf(student?.data.bform_url) ? (
//                         <img
//                           src="/images/pdf_icon.png" // Assuming your pdf icon is saved in public folder as "pdf-icon.png"
//                           alt="Bform PDF"
//                           className="itemImg"
//                         />
//                       ) : (
//                         <img
//                           src={student?.data.bform_url}
//                           alt="Bform Image"
//                           className="itemImg"
//                         />
//                       )}
//                       <div className="item">
//                         {isPdf(student?.data.marksheet_url) ? (
//                           <img
//                             src="/images/pdf_icon.png"
//                             alt="Marksheet PDF"
//                             className="itemImg"
//                           />
//                         ) : (
//                           <img
//                             src={student?.data.marksheet_url}
//                             alt="Marksheet Image"
//                             className="itemImg"
//                           />
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 {/* <div className="aformButton">
//                     {slugs && slugs.includes(AbsentformLinkString) && (
//                       <Link to={`/student/absent-form`} className=" link">
//                         <EventBusyIcon className="icon" />
//                         Absent Form
//                       </Link>
//                     )}
//                   </div>
//                   <div className="lformButton">
//                     {slugs && slugs.includes(LateformLinkString) && (
//                       <Link to={`/student/late-form`} className=" link">
//                         <CalendarTodayIcon className="icon" />
//                         Late Form
//                       </Link>
//                     )}
//                   </div>
//                   <div className="hlformButton">
//                     {slugs && slugs.includes(HalfleaveformLinkString) && (
//                       <Link to={`/student/half-leave-form`} className=" link">
//                         <AccessTimeIcon className="icon" />
//                         Half Leave Form
//                       </Link>
//                     )}
//                   </div>
//                   <div className="leformButton">
//                     {slugs && slugs.includes(LeaveformLinkString) && (
//                       <Link to={`/student/leave-form`} className=" link">
//                         <AccessTimeIcon className="icon" />
//                         Leave Form
//                       </Link>
//                     )}
//                   </div> */}
//                 <div className="details">
//                   <h1 className="itemTitle">{student?.data.name}</h1>
//                   {/* <div className="detailItem">
//                                               <span className="itemKey">Id: </span>
//                                               <span className="itemValue">{student?.data.id}</span>
//                                           </div> */}
//                   {/* <div className="detailItem">
//                                               <span className="itemKey">Name: </span>
//                                               <span className="itemValue">{student?.data.name}</span>
//                                           </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Bform Number: </span>
//                     <span className="itemValue">
//                       {student?.data.bform_number}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Phone Number: </span>
//                     <span className="itemValue">{student?.data.phone}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Father Name: </span>
//                     <span className="itemValue">
//                       {student?.data.father_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Father Phone Number: </span>
//                     <span className="itemValue">
//                       {student?.data.father_phone}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Father CNIC Number: </span>
//                     <span className="itemValue">
//                       {student?.data.father_cnic}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Email: </span>
//                     <span className="itemValue">{student?.data.email}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Address: </span>
//                     <span className="itemValue">{student?.data.address}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Roll Number: </span>
//                     <span className="itemValue">{student?.data.roll_no}</span>
//                   </div>
//                   {/* <div className="detailItem">
//                                               <span className="itemKey">Center Id: </span>
//                                               <span className="itemValue">{student?.data.center_id}</span>
//                                           </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Batch: </span>
//                     <span className="itemValue">
//                       {student?.data.batch_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Class: </span>
//                     <span className="itemValue">
//                       {student?.data.class_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Group: </span>
//                     <span className="itemValue">
//                       {student?.data.group_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">About Student: </span>
//                     <span className="itemValue">
//                       {student?.data.description}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Reference Name: </span>
//                     <span className="itemValue">{student?.data.ref_name}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Reference Phone Number: </span>
//                     <span className="itemValue">
//                       {student?.data.ref_phone_no}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Last Class Attended: </span>
//                     <span className="itemValue">
//                       {student?.data.last_class}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Last Grade: </span>
//                     <span className="itemValue">
//                       {student?.data.last_grade}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Last Percentage: </span>
//                     <span className="itemValue">
//                       {student?.data.percentage}%
//                     </span>
//                   </div>
//                 </div>
//                 {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{student?.data.status}</span>
//                                         </div> */}

//                 {/* <div className="right">
//                     <Chart aspect={3 / 1} title="User Spending ( Last 6 Months)" />
//                 </div> */}
//               </div>
//               {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default StudentSingle;
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Divider,
  Chip,
  Button,
  Box,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import {
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Home as HomeIcon,
  School as SchoolIcon,
  Groups as GroupsIcon,
  Description as DescriptionIcon,
  PersonPin as PersonPinIcon,
  CalendarMonth as CalendarMonthIcon,
  Grading as GradingIcon,
  Percent as PercentIcon,
} from "@mui/icons-material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const StudentSingle = () => {
  const location = useLocation();
  const studentId = location.pathname.match(/\/student\/(\d+)/)?.[1];
  const [student, setStudent] = useState(null);
  const token = localStorage.getItem("token");
  const slug = localStorage.getItem("slugs");
  const StudentSingleSlug = "Student-Single";
  const Checking = slug.includes(StudentSingleSlug);

  const redirectToLogin = () => {
    alert("Please login first to access this page");
    window.location.href = "/";
  };

  const fetchStudent = async () => {
    try {
      const response = await fetch(`${serverUrl}/student/${studentId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch student");
      }
      const data = await response.json();
      setStudent(data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch student data");
    }
  };

  const isPdf = (url) => {
    return url?.toLowerCase().endsWith(".pdf");
  };

  const handleDocumentClick = (url) => {
    if (isPdf(url)) {
      window.open(url, "_blank");
    }
  };

  useEffect(() => {
    if (studentId) {
      fetchStudent();
    }
  }, [studentId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  if (!Checking) {
    redirectToLogin();
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          <Navbar />
          <div className="contentWrapper">
            <Card className="formCard">
              <CardContent className="cardContent">
                <Typography
                  variant="h5"
                  component="h2"
                  gutterBottom
                  className="formTitle"
                >
                  Student Profile
                </Typography>

                {student && (
                  <Grid container spacing={3}>
                    {/* Student Profile Section */}
                    <Grid item xs={12} md={4}>
                      <div className="profileSection">
                        <div className="avatarContainer">
                          <Avatar
                            src={student?.data.image_url}
                            alt={student?.data.name}
                            sx={{
                              width: 150,
                              height: 150,
                              border: `3px solid ${theme.palette.primary.main}`,
                            }}
                          />
                          <Typography variant="h6" className="studentName">
                            {student?.data.name}
                          </Typography>
                          <Chip
                            label={`Roll #: ${student?.data.roll_no}`}
                            color="primary"
                            size="small"
                            sx={{ mb: 2 }}
                          />
                        </div>

                        <Divider sx={{ my: 2 }} />

                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          sx={{ fontWeight: 500 }}
                        >
                          Documents
                        </Typography>
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                          <Grid item xs={12}>
                            <Button
                              fullWidth
                              variant="outlined"
                              startIcon={<DescriptionIcon />}
                              onClick={() =>
                                handleDocumentClick(student?.data.bform_url)
                              }
                              sx={{
                                justifyContent: "flex-start",
                                textTransform: "none",
                              }}
                            >
                              {isPdf(student?.data.bform_url)
                                ? "View B-Form (PDF)"
                                : "View B-Form"}
                            </Button>
                          </Grid>
                          <Grid item xs={12}>
                            <Button
                              fullWidth
                              variant="outlined"
                              startIcon={<DescriptionIcon />}
                              onClick={() =>
                                handleDocumentClick(student?.data.marksheet_url)
                              }
                              sx={{
                                justifyContent: "flex-start",
                                textTransform: "none",
                              }}
                            >
                              {isPdf(student?.data.marksheet_url)
                                ? "View Marksheet (PDF)"
                                : "View Marksheet"}
                            </Button>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    {/* Student Details Section */}
                    <Grid item xs={12} md={8}>
                      <Grid container spacing={2}>
                        {/* Personal Information */}
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <PersonIcon
                              fontSize="small"
                              sx={{ mr: 1, color: theme.palette.primary.main }}
                            />
                            Personal Information
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <Grid container spacing={2}>
                            <DetailItem
                              icon={<PhoneIcon />}
                              label="Phone"
                              value={student?.data.phone}
                            />
                            <DetailItem
                              icon={<EmailIcon />}
                              label="Email"
                              value={student?.data.email}
                            />
                            <DetailItem
                              icon={<HomeIcon />}
                              label="Address"
                              value={student?.data.address}
                            />
                            <DetailItem
                              label="B-Form Number"
                              value={student?.data.bform_number}
                            />
                          </Grid>
                        </Grid>

                        {/* Father's Information */}
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mt: 3,
                              mb: 1,
                            }}
                          >
                            <PersonPinIcon
                              fontSize="small"
                              sx={{ mr: 1, color: theme.palette.primary.main }}
                            />
                            Father's Information
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <Grid container spacing={2}>
                            <DetailItem
                              label="Name"
                              value={student?.data.father_name}
                            />
                            <DetailItem
                              icon={<PhoneIcon />}
                              label="Phone"
                              value={student?.data.father_phone}
                            />
                            <DetailItem
                              label="CNIC"
                              value={student?.data.father_cnic}
                            />
                          </Grid>
                        </Grid>

                        {/* Academic Information */}
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mt: 3,
                              mb: 1,
                            }}
                          >
                            <SchoolIcon
                              fontSize="small"
                              sx={{ mr: 1, color: theme.palette.primary.main }}
                            />
                            Academic Information
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <Grid container spacing={2}>
                            <DetailItem
                              label="Batch"
                              value={student?.data.batch_names}
                            />
                            <DetailItem
                              label="Class"
                              value={student?.data.class_names}
                            />
                            <DetailItem
                              icon={<GroupsIcon />}
                              label="Group"
                              value={student?.data.group_names}
                            />
                          </Grid>
                        </Grid>

                        {/* Previous Academic Record */}
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mt: 3,
                              mb: 1,
                            }}
                          >
                            <GradingIcon
                              fontSize="small"
                              sx={{ mr: 1, color: theme.palette.primary.main }}
                            />
                            Previous Academic Record
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <Grid container spacing={2}>
                            <DetailItem
                              icon={<CalendarMonthIcon />}
                              label="Last Class Attended"
                              value={student?.data.last_class}
                            />
                            <DetailItem
                              icon={<GradingIcon />}
                              label="Last Grade"
                              value={student?.data.last_grade}
                            />
                            <DetailItem
                              icon={<PercentIcon />}
                              label="Last Percentage"
                              value={`${student?.data.percentage}%`}
                            />
                          </Grid>
                        </Grid>

                        {/* Additional Information */}
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mt: 3,
                              mb: 1,
                            }}
                          >
                            <DescriptionIcon
                              fontSize="small"
                              sx={{ mr: 1, color: theme.palette.primary.main }}
                            />
                            Additional Information
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <Grid container spacing={2}>
                            <DetailItem
                              label="Reference Name"
                              value={student?.data.ref_name}
                            />
                            <DetailItem
                              icon={<PhoneIcon />}
                              label="Reference Phone"
                              value={student?.data.ref_phone_no}
                            />
                            <DetailItem
                              label="About Student"
                              value={student?.data.description}
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

const DetailItem = ({ icon, label, value, fullWidth = false }) => (
  <Grid item xs={12} sm={fullWidth ? 12 : 6} md={fullWidth ? 12 : 4}>
    <div className="formInput">
      <label>{label}</label>
      <div className="detailValue">
        {icon &&
          React.cloneElement(icon, {
            fontSize: "small",
            sx: {
              color: "#7451f8",
              mr: 1,
              verticalAlign: "middle",
            },
          })}
        <span>{value || "-"}</span>
      </div>
    </div>
  </Grid>
);

export default StudentSingle;
